module.exports = __webpack_public_path__ + "img/future-of-rights-management.ab72a9a7.jpg";